import React from 'react';

export const LoadingSpinner = ({ overlay }: { overlay: boolean }): JSX.Element => {
    return (
        <div className='bs-loading-spinner'>
            <div className={overlay ? 'bs-loading-spinner__overlay' : 'bs-loading-spinner__wrapper'}>
                <div className='bs-loading-spinner__spinner' />
            </div>
        </div>
    );
};
